import { useQuery } from "@tanstack/react-query";
import { getDefinitions } from "../services/review.service";
import type { ReviewDefinitionsResponse } from "../types/review.types";

export const useDefinitions = () => {
  return useQuery<ReviewDefinitionsResponse>({
    queryKey: ["definitions"],
    queryFn: () => getDefinitions(),
  });
};
